import PropTypes from "prop-types";
import * as React from "react";
import { translate, Interpolate } from "react-i18next";
import get from "lodash/get";
import isEqual from "lodash/isEqual";
import isString from "lodash/isString";
import isUndefined from "lodash/isUndefined";
import unescape from "lodash/unescape";
import { x } from "helpers/localization";
import settings from "settings";
import { Button, ButtonGroup, DialogContainer, DialogHeader, DialogBody, DialogFooter, Textarea, Toggle } from "@wg/wows-react-uikit";
import { TooltipBody, Tooltip } from "components";

import styles from "./ClanEditDialogs.scss";

const propTypes = {
  rawDescription: PropTypes.string,
  savedDescription: PropTypes.string,
  error: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  isValidationError: PropTypes.bool,
  isFetching: PropTypes.bool,

  onEditDescriptionFormSubmit: PropTypes.func,
  onCloseClick: PropTypes.func,
  onClickClansRules: PropTypes.func,
  saveDialogState: PropTypes.func,
  t: PropTypes.func.isRequired
};

class ClanDescriptionEditDialog extends React.Component {

  constructor(props) {
    super(props);

    const {
      error,
      isValidationError
    } = this.parseError(props);
    const savedDescriptionPassed = isString(props.savedDescription);

    const isServerError = !!error && isValidationError;

    this.state = {
      description: savedDescriptionPassed ? props.savedDescription : props.rawDescription,
      isButtonDisabled: !savedDescriptionPassed || props.savedDescription === props.rawDescription || isServerError,
      error,
      isValidationError
    };

    this.getNormalizedDescription = this.getNormalizedDescription.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);

    this.maxChars = settings.editClanDescription.maxChars || 1000;
  }

  UNSAFE_componentWillReceiveProps(props) {// eslint-disable-line
    if (!isUndefined(props.error) && !isEqual(props.error, this.props.error)) {
      const {
        error,
        isValidationError
      } = this.parseError(props);
      this.setState({
        isButtonDisabled: !!error && isValidationError,
        isValidationError,
        error
      });
    }
  }

  componentWillUnmount() {
    this.saveDialogStateToStore();
  }

  getNormalizedDescription() {
    return this.state.description.trim().replace(/[ \t]{2,}/g, ' ');
  }

  parseError(data) {
    let error = null;
    let isValidationError = isUndefined(data.isValidationError) ? true : data.isValidationError;
    if (get(data, 'error.description.reason', null)) {
      error = data.error.description.reason;
    } else if (get(data, 'error.description', null)) {
      error = data.error.description[0];
    } else if (typeof data.error === 'string') {
      error = data.error;
    } else {
      error = get(data, 'error.message', null);
      isValidationError = false;
    }
    return { error, isValidationError };
  }

  onChange(description) {
    this.setState({
      description: description,
      error: null,
      isValidationError: false,
      isButtonDisabled: description === this.props.rawDescription
    });
  }

  onSubmit(event) {
    event.preventDefault();
    if (this.state.description === this.props.rawDescription) {
      return;
    }
    const description = this.getNormalizedDescription();
    this.props.onEditDescriptionFormSubmit({ description });
  }

  saveDialogStateToStore() {
    const {
      isValidationError,
      error
    } = this.state;
    const stateToSave = {
      savedDescription: this.getNormalizedDescription(),
      isValidationError,
      error
    };
    this.props.saveDialogState('clanDescription', stateToSave);
  }

  render() {
    const {
      description,
      isButtonDisabled,
      error,
      isValidationError
    } = this.state;
    const {
      t
    } = this.props;
    const clanRulesToggle = <Toggle caption={t('Правила кланов')} onClick={this.props.onClickClansRules} />;

    let tooltipContent = error && isValidationError ? t('Введите корректное описание') : null;
    if (description === this.props.rawDescription) {
      tooltipContent = description ? t('Измените описание') : t('Введите описание, удовлетворяющее Правилам кланов.');
    }

    return <DialogContainer>
                <DialogHeader>{t('Описание')}</DialogHeader>
                <DialogBody>
                    <Textarea value={unescape(description)} width="100%" height="270px" maxLength={this.maxChars} error={error} isCounted isFocusOn onChange={this.onChange} />
                </DialogBody>
                <DialogFooter>
                    <div className={styles.rules}>
                        <Interpolate i18nKey={x('При создании и изменении описания соблюдайте %(clanRules)s')} clanRules={clanRulesToggle} />
                    </div>
                    <ButtonGroup isLoading={this.props.isFetching}>
                        <Button isJustified isHighlighted isDisabled={isButtonDisabled} onClick={this.onSubmit} tooltipContent={tooltipContent ? <TooltipBody>{tooltipContent}</TooltipBody> : null} tooltipComponent={Tooltip} tooltipBodyComponent={TooltipBody}>
                            {t('Сохранить')}
                        </Button>
                        <Button isJustified onClick={this.props.onCloseClick}>{t('Отменить')}</Button>
                    </ButtonGroup>
                </DialogFooter>
            </DialogContainer>;
  }
}

ClanDescriptionEditDialog.propTypes = propTypes;

export default translate()(ClanDescriptionEditDialog);